import { ApiResponse, BorrowUserResponse, CurrencyType, MergedLoanCoin, UserLoanByCoin } from '@coin-depo-types';
import { Observable } from 'rxjs';

export interface BorrowStatsFacade {
  cachedBorrowsByCoin$: Observable<UserLoanByCoin[]>;
  cachedBorrowCreditLineLimit$: Observable<string>;
  cachedCurrentLoans$: Observable<string>;
  cachedBorrowAvailableCreditLimit$: Observable<string>;
  cachedBorrowLtv$: Observable<number>;
  cachedTotalAvailableBalance$: Observable<string>;
  cachedTotalUserLoans$: Observable<string>;
  cachedMergedLoansOfUser$: Observable<MergedLoanCoin[]>;

  getLoanStats(currency: CurrencyType): Observable<MergedLoanCoin[]>;
  getBorrowInfo(currency: CurrencyType): Observable<BorrowUserResponse>;
  getUserLoan?(amount: number, coin_id: number): Observable<ApiResponse>;
  repayUserLoan?(amount: number, loan_id: number): Observable<ApiResponse>;
}